import { render, staticRenderFns } from "./mapSettings.vue?vue&type=template&id=137c9358&scoped=true&"
import script from "./mapSettings.vue?vue&type=script&lang=js&"
export * from "./mapSettings.vue?vue&type=script&lang=js&"
import style0 from "./mapSettings.vue?vue&type=style&index=0&id=137c9358&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137c9358",
  null
  
)

export default component.exports